import * as actionTypes from '../types/settings';

export function getSettingsPlant(payload) {
  return {
    type: actionTypes.GET_SETTINGS_PLANT,
    payload
  };
}
export function getSettingsPlantSuccess(payload) {
  return {
    type: actionTypes.GET_SETTINGS_PLANT_SUCCESS,
    payload
  };
}
export function getSettingsPlantFail(payload) {
  return {
    type: actionTypes.GET_SETTINGS_PLANT_FAIL,
    payload
  };
}

export function setSettingsPlant(payload) {
  return {
    type: actionTypes.SET_SETTINGS_PLANT,
    payload
  };
}
export function setSettingsPlantSuccess(payload) {
  return {
    type: actionTypes.SET_SETTINGS_PLANT_SUCCESS,
    payload
  };
}
export function setSettingsPlantFail(payload) {
  return {
    type: actionTypes.SET_SETTINGS_PLANT_FAIL,
    payload
  };
}

export function messageDelete(payload) {
  return {
    type: actionTypes.MESSAGE_DELETE,
    payload
  };
}
export function messageDeleteSuccess(payload) {
  return {
    type: actionTypes.MESSAGE_DELETE_SUCCESS,
    payload
  };
}
export function messageDeleteFail(payload) {
  return {
    type: actionTypes.MESSAGE_DELETE_FAIL,
    payload
  };
}
export function messageSave(payload) {
  return {
    type: actionTypes.MESSAGE_SAVE,
    payload
  };
}
export function messageSaveSuccess(payload) {
  return {
    type: actionTypes.MESSAGE_SAVE_SUCCESS,
    payload
  };
}
export function messageSaveFail(payload) {
  return {
    type: actionTypes.MESSAGE_SAVE_FAIL,
    payload
  };
}
export function messageList(payload) {
  return {
    type: actionTypes.MESSAGE_LIST,
    payload
  };
}
export function messageListSuccess(payload) {
  return {
    type: actionTypes.MESSAGE_LIST_SUCCESS,
    payload
  };
}
export function messageListFail(payload) {
  return {
    type: actionTypes.MESSAGE_LIST_FAIL,
    payload
  };
}
export function messageRead(payload) {
  return {
    type: actionTypes.MESSAGE_READ,
    payload
  };
}
export function messageReadSuccess(payload) {
  return {
    type: actionTypes.MESSAGE_READ_SUCCESS,
    payload
  };
}
export function messageReadFail(payload) {
  return {
    type: actionTypes.MESSAGE_READ_FAIL,
    payload
  };
}
export function messageClear(payload) {
  return {
    type: actionTypes.MESSAGE_CLEAR,
    payload
  };
}

/** Получение параметров для holder_report */
export function getHolderSettingsPlant(payload) {
  return {
    type: actionTypes.GET_HOLDER_SETTINGS_PLANT,
    payload
  };
}
export function getHolderSettingsPlantSuccess(payload) {
  return {
    type: actionTypes.GET_HOLDER_SETTINGS_PLANT_SUCCESS,
    payload
  };
}
export function getHolderSettingsPlantFail(payload) {
  return {
    type: actionTypes.GET_HOLDER_SETTINGS_PLANT_FAIL,
    payload
  };
}

export function getMessageTemplate(payload) {
  return {
    type: actionTypes.MESSAGE_TEMPLATE,
    payload
  };
}

export function getMessageTemplateSuccess(payload) {
  return {
    type: actionTypes.MESSAGE_TEMPLATE_SUCCESS,
    payload
  };
}

export function getMessageTemplateFail(payload) {
  return {
    type: actionTypes.MESSAGE_TEMPLATE_FAIL,
    payload
  };
}

export function addMessageFiles(payload) {
  return {
    type: actionTypes.MESSAGE_FILES_ADD,
    payload
  };
}

export function addMessageFilesSuccess(payload) {
  return {
    type: actionTypes.MESSAGE_FILES_ADD_SUCCESS,
    payload
  };
}

export function addMessageFilesFail(payload) {
  return {
    type: actionTypes.MESSAGE_FILES_ADD_FAIL,
    payload
  };
}

export function getMessageFilesList(payload) {
  return {
    type: actionTypes.MESSAGE_FILES_LIST,
    payload
  };
}

export function getMessageFilesListSuccess(payload) {
  return {
    type: actionTypes.MESSAGE_FILES_LIST_SUCCESS,
    payload
  };
}

export function getMessageFilesListFail(payload) {
  return {
    type: actionTypes.MESSAGE_FILES_LIST_FAIL,
    payload
  };
}

export function deleteMessageFiles(payload) {
  return {
    type: actionTypes.MESSAGE_FILES_DELETE,
    payload
  };
}

export function deleteMessageFilesSuccess(payload) {
  return {
    type: actionTypes.MESSAGE_FILES_DELETE_SUCCESS,
    payload
  };
}

export function deleteMessageFilesFail(payload) {
  return {
    type: actionTypes.MESSAGE_FILES_DELETE_FAIL,
    payload
  };
}

export function messageOkPhotoInit(payload) {
  return {
    type: actionTypes.MESSAGE_OK_PHOTO_INIT,
    payload
  };
}

export function setSettingsTNPlant(payload) {
  return {
    type: actionTypes.SET_SETTINGS_TN_PLANT,
    payload
  };
}
export function setSettingsTNPlantSuccess(payload) {
  return {
    type: actionTypes.SET_SETTINGS_TN_PLANT_SUCCESS,
    payload
  };
}
export function setSettingsTNPlantFail(payload) {
  return {
    type: actionTypes.SET_SETTINGS_TN_PLANT_FAIL,
    payload
  };
}
